export const antillephoneScript = (id: string) => {
  return `
    !(function (t, f, a, x) {
      if (!document.getElementById(x)) {
        t.async = 1;
        t.defer = true;
        t.src = a;
        t.onload = execCactusEvents('antillephone');
        t.id = x;
        f.parentNode.insertBefore(t, f);
      }
    })(
      document.createElement("script"),
      document.getElementsByTagName("script")[0],
      'https://${id}.snippet.antillephone.com/apg-seal.js',
      "antillephone-script"
    );
    `;
};
